import React, { PureComponent } from 'react';
import CSSModules from 'react-css-modules';
import Translate from '@client/components/shared/translation/Translate';

import styles from './articleBadge.scss';

export class ArticleBadge extends PureComponent {
    static badgeMessage = {
        unisex: 'article.unisex'
    }

    render() {
        const { type } = this.props;
        const message = ArticleBadge.badgeMessage[type];

        return (
            <div styleName="wrapper">
                <Translate message={message} />
            </div>
        );
    }
}

export default CSSModules(ArticleBadge, styles);
